export default __webpack_public_path__ + "4308a2ac41462f4d9d1d54b61b7bebe3.png";